<template>
  <v-app>
    <Notify :message="message"/>
    <router-view/>
  </v-app>
</template>
<script>
import Notify from '@/components/common/Notify';
import { mapState } from 'vuex';
export default {
  name: 'App',
  components: { 
    Notify
  },
  computed: {
    ...mapState({
      message: state => state.notifyMod.message
    })
  }
};
</script>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap');
  *{
    /* font-family: 'Roboto', sans-serif; */
    font-family: 'Times New Roman', serif !important;
  }
  a{
    text-decoration: none;
  }
  .require .v-label:after,
  label.require:after {
    content: "*";
    color: red;
  }
  .container{
    padding: 6px !important;
  }
  .v-pagination__navigation{
    background: none !important;
    box-shadow: none !important;
  }
  .v-pagination__item:not(.v-pagination__item--active) {
    background: none !important;
    box-shadow: none !important;
  }
  .h-100 {
    height: 100% !important;
  }
  .min-h-30 {
    min-height: 30px !important;
  }
  .bg-transparent {
    background: transparent !important;
  }
  .dropzone-custom-border{
    border: 2px dashed #c7c4c4 !important;
  }
  .ql-container{
    min-height: inherit;
    max-height: 30rem;
    overflow-y: auto;
  }
</style>
